import { Square, ArrowUp, Paperclip } from 'lucide-react';
import { cn } from '@/lib/utils';
import { createButton } from './createButton';

interface StopGenerationButtonProps {
  onClick: () => void;
  size?: 'sm' | 'md';
}

export const StopGenerationButton = createButton<StopGenerationButtonProps>({
  className: (props) =>
    cn(
      'flex shrink-0 items-center justify-center rounded-lg bg-zinc-100 text-zinc-900 transition-opacity hover:opacity-90',
      props.size === 'sm' ? 'mb-[8.5px] mr-2.5 h-7 w-7' : 'h-8 w-8',
    ),
  content: (props) => (
    <Square className={cn(props.size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5')} />
  ),
});

interface SubmitMessageButtonProps {
  disabled: boolean;
  size?: 'sm' | 'md';
}

export const SubmitMessageButton = createButton<SubmitMessageButtonProps>({
  className: (props) =>
    cn(
      'flex shrink-0 items-center justify-center rounded-lg bg-zinc-100 text-zinc-900 transition-opacity disabled:opacity-30',
      props.size === 'sm' ? 'mb-[8.5px] mr-2.5 h-7 w-7' : 'h-8 w-8',
    ),
  content: (props) => (
    <ArrowUp className={cn(props.size === 'sm' ? 'h-4 w-4' : 'h-[22px] w-[22px]')} />
  ),
  type: 'submit',
});

interface AttachFileButtonProps {
  onClick: () => void;
  disabled: boolean;
  size?: 'sm' | 'md';
}

export const AttachFileButton = createButton<AttachFileButtonProps>({
  className: (props) =>
    cn(
      'flex shrink-0 items-center justify-center rounded-lg text-zinc-500 transition-colors hover:bg-white/[0.06] hover:text-zinc-300 disabled:cursor-not-allowed disabled:opacity-30',
      props.size === 'sm' ? 'mb-[8.5px] ml-2 h-7 w-7' : 'h-8 w-8',
    ),
  content: (props) => (
    <Paperclip className={cn(props.size === 'sm' ? 'h-4 w-4' : 'h-[22px] w-[22px]')} />
  ),
  title: 'Attach files',
});
